import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { messages } from '../messages/general-export-messages';
import asModal from '../../../as-modal';

import style from '../export-records-modal.module.less';

const DeleteExportFormatModal = ({ onClose, onDeleteExportFormat }) => {
  const onDelete = useCallback(() => {
    onDeleteExportFormat();
    onClose();
  }, [onDeleteExportFormat, onClose]);
  return (
    <Modal className={style['delete-format-modal']}>
      <ModalHeader closeModal={onClose}>
        <FormattedMessage {...messages.deleteFormatTitle} />
      </ModalHeader>
      <ModalBody className={style['modal-body']}>
        <div>
          <FormattedMessage {...messages.deleteFormatMessage} />
        </div>
      </ModalBody>
      <ModalFooter className={style['modal-footer']}>
        <Button onClick={onClose} theme='tertiary'>
          <FormattedMessage {...messages.cancel} />
        </Button>
        <Button onClick={onDelete} theme='primary'>
          <FormattedMessage {...messages.delete} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DeleteExportFormatModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDeleteExportFormat: PropTypes.func.isRequired,
};

export const DeleteFormatModal = asModal(DeleteExportFormatModal);
